import React from 'react'
import './Download_app.css'

const Download_app = () => {
    return (
        <>
            <section className="mobile-app-section who-we-are py-5">
                <div className="container">
                    <div className="row align-items-center left-content ">

                        {/* Left Content */}
                        <div className="col-lg-7 mb-4 mb-lg-0">
                            {/* <h2 className="fw-bold mb-3">
                                Learn Anytime, Anywhere with Our Mobile App
                            </h2> */}

                            <h2 className="section-title">
                                Learn Anytime, <span>Anywhere with Our Mobile App</span>
                            </h2>

                            <p className="fs-5 mb-3">
                                Access courses, learning materials, updates, and career resources
                                directly from your smartphone.
                            </p>

                            <p className="text-muted">
                                Download the PST IT Solutions mobile application and take your
                                learning experience wherever you go. Stay connected with course
                                updates, training programs, study materials, notifications, and
                                career opportunities—all in one place.
                            </p>

                            <div className="row mt-4">
                                <div className="col-md-6">
                                    <ul className="list-unstyled feature-list">
                                        <li>✔ Access Training Programs</li>
                                        <li>✔ Course Updates & Notifications</li>
                                        <li>✔ Learning Resources</li>
                                    </ul>
                                </div>

                                <div className="col-md-6">
                                    <ul className="list-unstyled feature-list">
                                        <li>✔ Career Guidance</li>
                                        <li>✔ Student Support</li>
                                        <li>✔ Anytime, Anywhere Learning</li>
                                    </ul>
                                </div>
                            </div>

                            <a
                                href="https://play.google.com/store/apps/details?id=co.khal.mwkiq&pcampaignid=web_share"
                                className="btn   download-btn mt-3"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="fab fa-google-play me-2"></i>
                                📱 Download App Now
                            </a>
                        </div>

                        {/* Right Image */}
                        <div className="col-lg-5 text-center">
                            <img
                                src={process.env.PUBLIC_URL + '/assets/images/pst_it_solution/download-app/mobile-mocup.png'}
                                alt="PST IT Solutions Mobile App"
                                className="img-fluid app-image"
                            />
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Download_app
